<ng-select
  [items]="allAgentItems$ | async"
  bindLabel="agent_name"
  [clearable]="true"
  [placeholder]="'CHOOSE_AGENT' | translate"
  [(ngModel)]="currentAgent"
  [loading]="loading"
  [trackByFn]="trackAgentByFn"
  [typeahead]="allAgentInput$"
  (change)="selectAgentChange()"
  [typeToSearchText]="'TYPE_TO_FIND_AN_AGENT' | translate"
  appendTo="body"
  style="position: relative"
>
  <ng-template ng-option-tmp let-item="item">
    <div class="">
      <div class="hstack gap-2">
        <span class="opacity-75">{{ "USERNAME" | translate }}:</span>
        <span>{{ item.agent_name || "-" }}</span>
      </div>
      <div class="hstack gap-2">
        <span class="opacity-75">{{ "NAME" | translate }}:</span>
        <span>{{ item.agent_contact_name || "-" }}</span>
      </div>
      <div class="hstack gap-2">
        <span class="opacity-75">{{ "TYPE" | translate }}:</span>
        <span>{{ item.typeDetail || "-" }}</span>
      </div>
      <div class="hstack gap-2">
        <span class="opacity-75">{{ "CREDIT" | translate }}:</span>
        <span>{{ item.credit_remaining || 0 | number : "0.2-2" }}</span>
      </div>
    </div>
  </ng-template>
</ng-select>
